var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 325",
    d: "M2 4C3.2 4 9.16667 4 12 4L9 1",
    stroke: "rgba(0, 0, 0, 0.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 326",
    d: "M12 8C10.8 8 4.83333 8 2 8L5 11",
    stroke: "rgba(0, 0, 0, 0.54)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.97f104198bc9dc46608cbbde311c97e3.svg";
export { ForwardRef as ReactComponent };